<ng-template
  #buttonTemplate
  let-buttons="buttons"
  let-state="state"
  [ngTemplateType]="ButtonTemplateType"
>
  <div layout>
    <rt-button
      #origin
      *ngFor="let button of buttons; let i = index; trackBy: trackByValue"
      (click)="onButtonClick(button, origin.elRef.nativeElement)"
      [style.background]="state[i] ? 'lightblue' : null"
      variant="plain only-icon small-x"
    >
      <rt-icon [name]="button.icon"></rt-icon>
      {{ button.name }}
    </rt-button>
  </div>
</ng-template>

<ng-container
  *ngTemplateOutlet="buttonTemplate; context: { buttons: leftOutlet, state: leftOutletState }"
></ng-container>
<ng-container
  *ngTemplateOutlet="buttonTemplate; context: { buttons: rightOutlet, state: rightOutletState }"
></ng-container>
